module.exports = __webpack_public_path__ + "img/paci_ar_7.cde1455f.png";